// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"e1d88c06","837":"54ed7cf2"}[chunkId] + ".chunk.css";
};